export const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(17, 24, 39, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    zIndex: 10002,
  },
  modal: {
    width: 'min(860px, 100%)',
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
    overflow: 'hidden',
  },
 header: {
  padding: '18px 20px 12px',
  borderBottom: '1px solid #E5E7EB',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
},

headerTop: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between', 
},

headerBottom: {
  display: 'flex',
  justifyContent: 'flex-end',
},

headerLeft: {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  minWidth: 0,
},

qDivider: {
  width: '100%',
  height: 1,
  backgroundColor: '#D1D5DB',
  marginTop: 10,
  marginBottom: 25,
},

title: {
  fontSize: 18,
  fontWeight: 800,
  color: '#111827',
  lineHeight: '22px',
},

counterPill: {
  background: '#F3F4F6',
  border: '1px solid #E5E7EB',
  borderRadius: 999,
  padding: '4px 10px',
  fontSize: 12,
  fontWeight: 700,
  color: '#111827',
  whiteSpace: 'nowrap',
},

progressTrack: {
  width: '100%',
  height: 6,
  background: '#E5E7EB',
  borderRadius: 999,
  overflow: 'hidden',
},

progressFill: (pct) => ({
  height: '100%',
  width: `${pct}%`,
  background: '#1C4B75',
  borderRadius: 999,
}),

  titleRow: { display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 },
  title: { fontSize: 18, fontWeight: 800, color: '#111827', lineHeight: '22px' },
  counterPill: {
    alignSelf: 'flex-start',
    background: '#F3F4F6',
    border: '1px solid #E5E7EB',
    borderRadius: 999,
    padding: '4px 10px',
    fontSize: 12,
    fontWeight: 700,
    color: '#111827',
    whiteSpace: 'nowrap',
  },

  progressTrack: {
    width: '100%',  
    height: 6,
    background: '#E5E7EB',
    borderRadius: 999,
    overflow: 'hidden',
    marginTop: 10,
  },
  progressFill: (pct) => ({
    height: '100%',
    width: `${pct}%`,
    background: '#1C4B75',
    borderRadius: 999,
  }),
  body: {
    padding: 18,
    maxHeight: 'calc(100vh - 220px)',
    overflow: 'auto',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 14,
  },
  questionCard: ({ active, error }) => ({
    border: error
      ? '2px solid #DC2626'
      : active
      ? '2px solid #1C4B75'
      : '1px solid #E5E7EB',
    borderRadius: 14,
    padding: 14,
    transition: 'border-color 150ms ease, background 150ms ease',
  }),
  qTop: { display: 'flex', gap: 10, alignItems: 'flex-start' },
  qNumber: {
    width: 28,
    height: 28,
    borderRadius: 999,
    background: '#F3F4F6',
    border: '1px solid #E5E7EB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 900,
    color: '#111827',
    flex: '0 0 auto',
  },

  qText: {
    fontSize: 15,
    fontWeight: 800,
    color: '#111827',
    lineHeight: '20px',
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  boolRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 12,
  },

  boolBtn: (selected) => ({
    flex: '1 1 0',
    minWidth: 0,
    minHeight: 44,
    borderRadius: 12,
    border: selected ? '2px solid #1C4B75' : '1px solid #E5E7EB',
    background: selected ? '#EFF6FF' : '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 12px',
    fontWeight: 800,
    color: '#111827',
    textAlign: 'center',
    lineHeight: '16px',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  }),

  textarea: {
    width: '100%',
    minHeight: 92,
    borderRadius: 12,
    border: '1px solid #E5E7EB',
    padding: 12,
    outline: 'none',
    fontSize: 14,
    marginTop: 12,
    resize: 'vertical',
  },

  fileBox: (hasFile) => ({
    marginTop: 12,
    borderRadius: 12,
    border: `1px dashed ${hasFile ? '#1C4B75' : '#D1D5DB'}`,
    background: hasFile ? '#EFF6FF' : '#F9FAFB',
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
  }),
  fileLeft: { display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 },
  fileName: {
    fontSize: 13,
    color: '#111827',
    fontWeight: 700,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  fileHint: { fontSize: 12, color: '#6B7280', fontWeight: 600 },

  footer: {
    padding: 16,
    borderTop: '1px solid #E5E7EB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    background: '#fff',
  },
  leftFooter: { display: 'flex', alignItems: 'center', gap: 10 },
  rightFooter: { display: 'flex', alignItems: 'center', gap: 10 },

  missing: { fontSize: 12, color: '#9CA3AF', fontWeight: 700 },

};
